import { AppVersion } from '@evorait/pace-core';

export function humanReadableVersion(appVersion: AppVersion): string {
    return appVersion.version ?? `${appVersion.commitHash} (${appVersion.branchName})`;
}

export function detailedVersionString(appVersion: AppVersion): string {
    const version = appVersion.version ?? 'unknown version';
    const tag = appVersion.tag ? `Tag: ${appVersion.tag}` : 'Tag: none';
    const commitHash = `Commit: ${appVersion.commitHash}`;
    const branchName = `Branch: ${appVersion.branchName}`;
    const timestamp = `Built on: ${appVersion.timestamp}`;

    return `${version} | ${tag} | ${commitHash} | ${branchName} | ${timestamp}`;
}
